/**
 * English -> Hebrew book names, covering both the 5 Torah books and the Nevi'im/Ketuvim
 * books that appear as Haftara sources (see client/src/data/haftarot.json). No existing
 * map in the codebase covers Haftara books — the four Torah-only maps (ParashaChooser,
 * RabbiUploadPage, BirthDatePage, ChooseParshaPage) only handle the 5 Chumash books.
 */
export const TANACH_BOOK_HEBREW: Record<string, string> = {
  Bereshit: 'בראשית',
  Shemot: 'שמות',
  Vayikra: 'ויקרא',
  Bamidbar: 'במדבר',
  Devarim: 'דברים',
  Joshua: 'יהושע',
  Judges: 'שופטים',
  'I Samuel': 'שמואל א',
  'II Samuel': 'שמואל ב',
  'I Kings': 'מלכים א',
  'II Kings': 'מלכים ב',
  Isaiah: 'ישעיהו',
  Jeremiah: 'ירמיהו',
  Ezekiel: 'יחזקאל',
  Hosea: 'הושע',
  Joel: 'יואל',
  Amos: 'עמוס',
  Obadiah: 'עובדיה',
  Micah: 'מיכה',
  Zephaniah: 'צפניה',
  Zechariah: 'זכריה',
  Malachi: 'מלאכי',
};

/** Returns the Hebrew book name, or the original value if unmapped. */
export function getTanachBookHebrew(book: string | number | null | undefined): string {
  if (book == null) return '';
  const key = String(book);
  return TANACH_BOOK_HEBREW[key] ?? key;
}
